import { useQuery, UseQueryResult } from 'react-query';
import { api } from '../api';
import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { GetResponseBody } from '../types/api-response';
import { WorksheetEntry } from '../types/worksheet-entry';
import { WorksheetEntryV2 } from '../types/worksheet';

type UseEntriesConfig = {
    sort: string;
};

async function getEntries(
    { sort }: UseEntriesConfig,
    workpaperId: string,
    worksheetId: string
): Promise<GetResponseBody<WorksheetEntry[]>> {
    const query = `${sort}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/worksheets/${worksheetId}/entries?${query}`);
    return data;
}

export function useEntries({ sort }: UseEntriesConfig, worksheetId: string): UseQueryResult<GetResponseBody<WorksheetEntry[]>, unknown> {
    const { id: workpaperId } = useWorkpaperContext();
    return useQuery(['entries', worksheetId, sort], () => getEntries({ sort }, workpaperId, worksheetId), {
        keepPreviousData: true,
    });
}

async function getEntriesV2(
    { sort }: UseEntriesConfig,
    workpaperId: string,
    worksheetId: string
): Promise<GetResponseBody<WorksheetEntryV2[]>> {
    const query = `${sort}`;
    const { data } = await api.get(`/workpapers/${workpaperId}/worksheets/${worksheetId}/entries?${query}`);
    return data;
}

export function useEntriesV2(
    worksheetId: string,
    { sort }: UseEntriesConfig = { sort: '' },
    overrideWorkpaperId?: string
): UseQueryResult<GetResponseBody<WorksheetEntryV2[]>, unknown> {
    const { id: contextWorkpaperId } = useWorkpaperContext();
    const workpaperId = overrideWorkpaperId || contextWorkpaperId;
    return useQuery(['entries', worksheetId, sort], () => getEntriesV2({ sort }, workpaperId, worksheetId), {
        keepPreviousData: true,
    });
}
